import React from "react";
import "./CreateMonthlyReimbursement.css";
import MonthlyReimbursementForm from "./MonthlyReimbursementForm";

const MonthlyReimbursement = () => {
	return <MonthlyReimbursementForm />;
};
export default MonthlyReimbursement;
